import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { GetNextWeek, GetPreviousWeek, GetDates, GetDayName, GetStartingDates, CheckIsToday } from "./CalendarUtil";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { AiOutlineArrowRight, AiOutlineArrowLeft } from "react-icons/ai";

import { v4 as uuidv4 } from "uuid";

const DateButton = ({ dateObj, setDate, date }) => {
  const [toggleActive, setToggleActive] = useState(false);

  const handleDateClick = () => {
    setDate(dateObj);
  };

  const getPlanDate = (d) => d.toLocaleDateString("en-GB").replaceAll("/", "");

  return (
    <button
      className={`date ${getPlanDate(dateObj) === getPlanDate(date) ? "is-active pulseAnimation" : ""}`}
      title={dateObj.toDateString()}
      onClick={handleDateClick}
    >
      <span className="day">{GetDayName(dateObj).slice(0, 3)}</span>
      <span className="dateNum">{dateObj.getDate()}</span>
    </button>
  );
};

const Carousel = ({ dateRange, setDate, date }) => {
  const sliderRef = useRef(null);
  const getPlanDate = (d) => d.toLocaleDateString("en-GB").replaceAll("/", "");

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 11,
    slidesToScroll: 11,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1420,
        settings: {
          slidesToShow: 11,
          slidesToScroll: 11,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1220,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 11,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 11,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 830,
        settings: {
          slidesToShow: 6,
          slidesToShow: 6,
          slidesToScroll: 6,
          initialSlide: 0,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 6,
          slidesToShow: 6,
          slidesToScroll: 6,
          initialSlide: 0,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          initialSlide: 0,
          infinite: false,
          dots: false,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 5,
          initialSlide: 0,
          infinite: false,
          dots: false,
        },
      },
    ],
  };

  useEffect(() => {
    setTimeout(() => {
      let b = sliderRef.current?.state?.breakpoint ?? null;
      let r = b == null ? 5 : b == 1024 ? 3 : b == 600 ? 2 : 2;

      sliderRef?.current?.props?.children?.map((da, i) => {
        if (getPlanDate(da.props.dateObj) === getPlanDate(da.props.date)) {
          sliderRef.current.slickGoTo(i - r);
        }
      });
    }, 400);
  }, [dateRange, date]);

  return (
    <>
      <div className="row align-items-center h-100">
        <div className="col-1 hide-on-mobile pull-left text-left" onClick={() => sliderRef.current.slickPrev()}>
          <FaChevronLeft />
        </div>
        <div className="col-10 mx-auto ">
          <Slider {...settings} ref={sliderRef}>
            {dateRange.map((d) => (
              <DateButton dateObj={d} {...{ setDate, date }} key={uuidv4()} />
            ))}
          </Slider>
        </div>
        <div className="col-1 hide-on-mobile pull-right text-right" onClick={() => sliderRef.current.slickNext()}>
          <FaChevronRight />
        </div>
      </div>
      <div className="row mt-3 hide-on-desktop show-on-mobile">
        <div className="col-6 text-right">
          <FaChevronLeft onClick={() => sliderRef.current.slickPrev()} />
        </div>
        <div className="col-6 text-left">
          <FaChevronRight onClick={() => sliderRef.current.slickNext()} />
        </div>
      </div>
    </>
  );
};

const Calendar = ({ date, setDate, premium = true }) => {
  //Design Inspiration Link: https://www.espn.com/mens-college-basketball/scoreboard

  const [dateRange, setDateRange] = useState([]);

  useEffect(() => {
    setDateRange(GetStartingDates(date, premium));
  }, []);

  return (
    <div className="Calendar">
      {date && dateRange.length > 0 ? <Carousel {...{ date, setDate, dateRange }}></Carousel> : null}
    </div>
  );
};

export default Calendar;
